<template lang="pug">
#news
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    #accordion.mb-5
      .news_card.mb-4.border-radius-10(
        v-for="news in newsList",
        :key="news.id"
      )
        #headingOne.news_card_header
          img(src="@/assets/img/logo/logo_icon.svg")
          span.mb-0.ml-1(style="font-size: 16px; font-weight: bold") TOP巔峰籃球訓練營
          span.ml-2(style="font-size: 16px; font-weight: 300") 發布了一則新消息——
          .post-date {{ news.last_modify_date }}
        #collapseOne.collapse.show(@click="readMoreClick(news.id)")
          .card-body
            .row
              .col-12.pl-0.pr-0
                .news_img(
                  v-if="news.photo",
                  :style="{ backgroundImage: 'url(' + news.photo.image + ')' }"
                )
              .col-12.pl-0.pr-0
                h2 {{ news.title }}
                h4 {{ news.subtitle }}
                .float-right.read_more ...繼續閱讀
                  span
                    font-awesome-icon.right_arrow(
                      :icon="['fas', 'chevron-right']"
                    )
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getNewsList } from "@/api/web_content";

export default {
  name: "News",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "最新消息",
      newsList: [],
    };
  },
  created() {
    this.getNewses();
  },
  methods: {
    readMoreClick(newsId) {
      this.$router.push({ name: "NewsDetail", query: { id: newsId } });
    },
    getNewses() {
      getNewsList().then((response) => {
        this.newsList = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#news {
  background-color: $color_bg_white;
  min-height: calc(100vh - 80px);
  position: relative;
}

.news_card {
  background: white;
}

.news_img {
  width: 100%;
  height: auto;
  min-height: 320px;
  background-color: #ccc;
  background-size: cover;
  background-position: center center;
}

#collapseOne {
  cursor: pointer;
}
.post-date {
  line-height: 30px;
  font-size: 16px;
  float: right;
}

.right_arrow {
  margin-left: 10px;
  font-size: 20px;
  color: $color_blue;
}

h2 {
  font-size: 32px;
  margin-top: 15px;
}

h4 {
  font-size: 24px;
  margin-top: 15px;
  font-weight: 300;
}

.read_more {
  line-height: 20px;
  font-size: 20px;
  color: $c-text;
}

@media (max-width: 767px) {
  .news_card {
    border-radius: 10px;
    box-shadow: 2px 2px 16px #00000023;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 35px;
    padding-bottom: 45px;
  }

  .post-date {
    clear: right;
    float: none;
  }

  .read_more {
    margin-top: 20px;
  }
}
</style>
